// extracted by extract-css-chunks-webpack-plugin
module.exports = {"auto_list":"auto_list-2oYxvfDp"};